// services/label.service.js
import { apiService } from "../../app.service";

export const labelApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    // Category endpoints
    fetchCategories: builder.query({
      query: () => ({
        url: "/user/label/categories",  // Changed: added /user prefix
      }),
      providesTags: ["Category"],
    }),
    fetchCategory: builder.query({
      query: (id) => ({
        url: `/user/label/categories/${id}`,  // Changed
      }),
      providesTags: (result, error, id) => [{ type: "Category", id }],
    }),
    createCategory: builder.mutation({
      query: (data) => ({
        url: "/user/label/categories",  // Changed
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Category"],
    }),
    updateCategory: builder.mutation({
      query: ({ id, data }) => ({
        url: `/user/label/categories/${id}`,  // Changed
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "Category", id }],
    }),
    deleteCategory: builder.mutation({
      query: (id) => ({
        url: `/user/label/categories/${id}`,  // Changed
        method: "DELETE",
      }),
      invalidatesTags: ["Category"],
    }),

    // Allergen endpoints
    fetchAllergens: builder.query({
      query: () => ({
        url: "/user/label/allergens",  // Changed
      }),
      providesTags: ["Allergen"],
    }),
    createAllergen: builder.mutation({
      query: (data) => ({
        url: "/user/label/allergens",  // Changed
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Allergen"],
    }),
    updateAllergen: builder.mutation({
      query: ({ id, data }) => ({
        url: `/user/label/allergens/${id}`,  // Changed
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "Allergen", id }],
    }),
    deleteAllergen: builder.mutation({
      query: (id) => ({
        url: `/user/label/allergens/${id}`,  // Changed
        method: "DELETE",
      }),
      invalidatesTags: ["Allergen"],
    }),

    // Product endpoints
    fetchProducts: builder.query({
      query: ({ categoryId, search } = {}) => {
        let url = "/user/label/products";  // Changed
        const params = new URLSearchParams();
        if (categoryId) params.append("categoryId", categoryId);
        if (search) params.append("search", search);
        if (params.toString()) url += `?${params.toString()}`;
        return { url };
      },
      providesTags: ["Product"],
    }),
    fetchProductsByCategory: builder.query({
      query: (categoryId) => ({
        url: `/user/label/products/category/${categoryId}`,  // Changed
      }),
      providesTags: (result, error, categoryId) => [
        { type: "Product", categoryId },
      ],
    }),
    fetchProduct: builder.query({
      query: (id) => ({
        url: `/user/label/products/${id}`,  // Changed
      }),
      providesTags: (result, error, id) => [{ type: "Product", id }],
    }),
    createProduct: builder.mutation({
      query: (data) => ({
        url: "/user/label/products",  // Changed
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Product"],
    }),
    updateProduct: builder.mutation({
      query: ({ id, data }) => ({
        url: `/user/label/products/${id}`,  // Changed
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "Product", id }],
    }),
    deleteProduct: builder.mutation({
      query: (id) => ({
        url: `/user/label/products/${id}`,  // Changed
        method: "DELETE",
      }),
      invalidatesTags: ["Product"],
    }),

    // Print Queue endpoints
    fetchPrintQueue: builder.query({
      query: () => ({
        url: "/user/label/print-queue",  // Changed
      }),
      providesTags: ["PrintQueue"],
    }),
    addToPrintQueue: builder.mutation({
      query: (data) => ({
        url: "/user/label/print-queue",  // Changed
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["PrintQueue"],
    }),
    removeFromPrintQueue: builder.mutation({
      query: (id) => ({
        url: `/user/label/print-queue/${id}`,  // Changed
        method: "DELETE",
      }),
      invalidatesTags: ["PrintQueue"],
    }),
    clearPrintQueue: builder.mutation({
      query: () => ({
        url: "/user/label/print-queue/clear/all",  // Changed
        method: "DELETE",
      }),
      invalidatesTags: ["PrintQueue"],
    }),
    printLabels: builder.mutation({
      query: (data) => ({
        url: "/user/label/print",  // Changed
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["PrintQueue"],
    }),
  }),
});

export const {
  // Category hooks
  useFetchCategoriesQuery,
  useFetchCategoryQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  // Allergen hooks
  useFetchAllergensQuery,
  useCreateAllergenMutation,
  useUpdateAllergenMutation,
  useDeleteAllergenMutation,
  // Product hooks
  useFetchProductsQuery,
  useFetchProductsByCategoryQuery,
  useFetchProductQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useDeleteProductMutation,
  // Print Queue hooks
  useFetchPrintQueueQuery,
  useAddToPrintQueueMutation,
  useRemoveFromPrintQueueMutation,
  useClearPrintQueueMutation,
  usePrintLabelsMutation,
} = labelApi;